export default __webpack_public_path__ + "static/media/four-color.151a5cc6.jpg";